let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4tqAr")).then(() => parcelRequire('7YZnR'));